var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m11.387 11.918.531-.531a.283.283 0 0 0 0-.399L9.074 8.145a.28.28 0 0 0-.199-.082h-.312a4.86 4.86 0 0 0 .746-5.215 4.876 4.876 0 1 0-6.46 6.46 4.86 4.86 0 0 0 5.214-.745v.312c0 .074.03.145.082.2l2.843 2.843c.114.11.29.11.399 0M4.875 8.625a3.751 3.751 0 0 1 0-7.5 3.751 3.751 0 0 1 0 7.5m0 0",
    clipRule: "evenodd"
  })));
};
export default SvgMagnifyingGlass;